import { render, staticRenderFns } from "./TextScrollModule.vue?vue&type=template&id=191ec664&"
import script from "./TextScrollModule.ts?vue&type=script&lang=ts&"
export * from "./TextScrollModule.ts?vue&type=script&lang=ts&"
import style0 from "./TextScrollModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports